<template>
    <reo-dialog
        @cancel="handleCancel"
        class='email-subscribe'
        :showButton=false>
        <h4 class="title">{{ $t('emailSubscription.title') }}</h4>
        <email-subscription subject="cloud-update" ></email-subscription>
    </reo-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import emailSubscription from '@/components/emailSubscription.vue';

export default Vue.extend({
    name: 'EmailSubscribeDialog',
    components: {
        ReoDialog,
        emailSubscription
    },
    props: {
    },
    methods: {
        handleConfirm() {

            this.$emit( 'confirm' );

        },

        handleCancel() {

            this.$emit( 'cancel' );

        }
    }

});
</script>

<style lang="less" scoped>
/deep/ .checkbox-container{
    margin-top: 16px;
}

h4{
    font-size: 24px;
    font-weight: 600;
    text-align: center;
    .mobile({
        font-size: 18px
    });
}
</style>
